export class HmacUtil {
    private static encoder = new TextEncoder();

    static async generateHmacBase64(
        message: string,
        secret: string
    ): Promise<string> {

        const key = await crypto.subtle.importKey(
            'raw',
            this.encoder.encode(secret),
            { name: 'HMAC', hash: 'SHA-256' },
            false,
            ['sign']
        );

        const signature = await crypto.subtle.sign(
            'HMAC',
            key,
            this.encoder.encode(message)
        );

        return this.arrayBufferToBase64(signature);
    }

    private static arrayBufferToBase64(buffer: ArrayBuffer): string {
        const bytes = new Uint8Array(buffer);
        let binary = '';
        for (const b of bytes) {
            binary += String.fromCharCode(b);
        }
        return btoa(binary);
    }
}
